export default {
  props: { value: { type: Array, default: () => [] } },
  data() {
    return { loading: false, list: [], query: '', focused: false }
  },
  watch: {
    query(v) {
      clearTimeout(this.timeout)
      this.list = []
      if (v) {
        this.timeout = setTimeout(() => {
          this.fetchData()
        }, 400)
      }
    },
  },
}
